<template>
	<section class="blocks" id="block7" :style="{ background: bg_color }">
		<div class="container">
			<h2 class="title-box">{{ title }}</h2>
			<article v-html="content">

			</article>
		</div>
	</section>
</template>

<script>
    export default {
        props: ["title", "content", "figure", "bg_color"]
    }
</script>

<style lang="scss">
	#block7 {

		article {
			p {
				width: 90% ;
				color: #222831;
				font-size: 1.6em;
				line-height: 24px;
				margin: 0 auto 25px auto;
			}
		}

		figure {
			padding: 40px 0;
			text-align: center;
		}
	}

	@media (max-width: 640px) {
		#block7 {
			article {
				p {
					width: 100%;
					margin: 20px auto;
					text-align: left !important;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/blocks/Block7.vue